import React from "react";
import { useParams, Link } from "react-router-dom";
import { FileText, ArrowLeft } from "lucide-react";
import { LEGAL } from "../mock";
import { useSeo } from "../hooks/useSeo";

const MAP = { disclaimer: "disclaimer", privacy: "privacy", policies: "privacy", terms: "terms" };

const LegalPage = ({ type }) => {
  const params = useParams();
  const key = MAP[type || params.type] || "terms";
  const data = LEGAL[key];
  useSeo({ title: data?.title || "Page not found", description: `${data?.title || "Legal"} for British Supplements, a UK supplement brand.` });

  if (!data) {
    return (
      <div className="mx-auto max-w-3xl px-6 py-24 text-center">
        <h1 className="font-display text-3xl font-bold uppercase text-[#1B4332]">Page not found</h1>
      </div>
    );
  }

  return (
    <div>
      <div className="relative overflow-hidden bg-[#1B4332]">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d281d] to-[#1B4332]/70" />
        <div className="relative mx-auto max-w-4xl px-4 py-14 sm:px-6">
          <div className="mb-2 flex items-center gap-2 text-xs text-[#95D5B2]">
            <Link to="/" className="hover:text-white">Home</Link><span>/</span><span className="text-white">{data.title}</span>
          </div>
          <div className="flex items-center gap-3">
            <FileText className="text-[#95D5B2]" size={30} />
            <h1 className="font-display text-4xl font-bold uppercase text-white sm:text-5xl">{data.title}</h1>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <p className="text-lg leading-relaxed text-[#34463c]">{data.intro}</p>
        <div className="mt-8 space-y-7">
          {data.sections.map((s, i) => (
            <div key={i} className="border-l-4 border-[#52B788] pl-5">
              <h2 className="font-display text-lg font-bold uppercase tracking-wide text-[#1B4332]">{s.h}</h2>
              <p className="mt-2 leading-relaxed text-[#4a5c51]">{s.p}</p>
            </div>
          ))}
        </div>
        <p className="mt-10 text-sm text-[#8aa093]">Last updated: {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long" })}. This is concept copy for a design prototype.</p>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-wider text-[#2D6A4F] hover:text-[#1B4332]">
          <ArrowLeft size={15} /> Back Home
        </Link>
      </div>
    </div>
  );
};

export default LegalPage;
